<script>
import { Bar } from "vue-chartjs";

export default {
    extends: Bar,
    props: [
        // This has been disabled in the initial lint setup - if you are working on this page please determine the correct type for these properties
        //eslint-disable-next-line
        "data",
        // This has been disabled in the initial lint setup - if you are working on this page please determine the correct type for these properties
        //eslint-disable-next-line
        "options"
    ],
    computed: {
        chartData: function() {
            return this.data;
        }
    },
    methods: {
        getImage() {
            return this.$refs.canvas.toDataURL("image/png");
        },
        // update() {
        //     this.$data._chart.destroy();

        //     this.renderChart(this.chartData, this.options);
        // }
    },
    mounted() {
        this.renderChart(this.chartData, this.options);
    },
    watch: {
        data: {
            handler() {
                this.$data._chart.destroy();

                this.renderChart(this.chartData, this.options);

                //this.$data._chart.update();
            },
            deep: true
        }
    }
};
</script>

<style>
    
</style>